export enum TournamentMatchStage {
    FINAL = 'FINAL',
    SEMIFINAL = 'SEMIFINAL',
    QUARTER_FINAL = 'QUARTER_FINAL',
    PLAYOFFS = 'PLAYOFFS',
    GROUPS = 'GROUPS',
}
